import React from 'react';

const QuoteIcon: React.FC = (): React.ReactElement => {
  return (
    <>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <g id="Navigation/Quote">
          <path
            id="Combined Shape"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.99959 2.625C8.29344 3.56512 7.875 4.73369 7.875 6C7.875 9.1066 10.3934 11.625 13.5 11.625C13.8853 11.625 14.2615 11.5863 14.625 11.5125V18.375H3.375V2.625H8.99959ZM10.1245 1.5H2.25V19.5H15.75V11.157C17.7366 10.2889 19.125 8.30661 19.125 6C19.125 2.8934 16.6066 0.375 13.5 0.375C12.2334 0.375 11.0647 0.793601 10.1245 1.5ZM15.75 2.10202C17.0951 2.88009 18 4.33436 18 6C18 7.66564 17.0951 9.11991 15.75 9.89798L15.7399 9.9038C15.3945 10.1024 15.0203 10.2565 14.625 10.3582C14.2654 10.4508 13.8885 10.5 13.5 10.5C11.0147 10.5 9 8.48528 9 6C9 4.65597 9.58922 3.44956 10.5234 2.625C10.5609 2.59191 10.599 2.55943 10.6376 2.52758C11.4154 1.88563 12.4127 1.5 13.5 1.5C14.3196 1.5 15.0881 1.71914 15.75 2.10202ZM4.5 16.125H11.8125V17.25H4.5V16.125ZM13.5 13.5938H4.5V14.7188H13.5V13.5938ZM4.5 11.0625H9V12.1875H4.5V11.0625ZM11.8125 6.44522V5.6625H12.4675V5.30672C12.4675 4.33641 12.9267 3.78656 13.8841 3.78656C14.2399 3.78656 14.5633 3.85125 14.8738 3.96122L14.7509 4.84744C14.5633 4.76981 14.3046 4.71806 14.0846 4.71806C13.6836 4.71806 13.4895 4.93153 13.4895 5.38434V5.6625H14.5744V6.44522H13.4895V6.70397C13.4895 7.03387 13.4248 7.27969 13.2049 7.422V7.43494H14.7962V8.25H12.0729L12.0405 7.47375C12.364 7.37672 12.4675 7.15678 12.4675 6.80747V6.44522H11.8125Z"
            fill="white"
          />
        </g>
      </svg>
    </>
  );
};

export default QuoteIcon;
